export default (record) => {
  if (!record) {
    return true;
  }
  return (!!record.leave_id && record.type === 'Absence') || !!record.event_id;
};
